module.exports = __webpack_public_path__ + "static/media/30.a5e876c5.jpg";